import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { validateOutputOptions as validate } from './static.js';
import { format as formatData } from '../plugins/output.js';
import { clean as parseCsl } from '../plugins/input/csl.js';
export function getIds() {
  return this.data.map(function (entry) {
    return entry.id;
  });
}
export function format(format) {
  for (var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    options[_key - 1] = arguments[_key];
  }

  return formatData.apply(void 0, [format, parseCsl(this.data)].concat(options));
}
export function get() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validate(options);
  var parsedOptions = Object.assign({}, this.defaultOptions, this._options.output, options);
  var type = parsedOptions.type,
      style = parsedOptions.style;

  var _style$split = style.split('-'),
      _style$split2 = _slicedToArray(_style$split, 2),
      styleType = _style$split2[0],
      styleFormat = _style$split2[1];

  var newStyle = styleType === 'citation' ? 'bibliography' : styleType === 'csl' ? 'data' : styleType;
  var newType = type === 'string' ? 'text' : type === 'json' ? 'object' : type;
  var formatOptions;

  switch (newStyle) {
    case 'bibliography':
      {
        var lang = parsedOptions.lang,
            append = parsedOptions.append,
            prepend = parsedOptions.prepend;
        formatOptions = {
          template: styleFormat,
          lang: lang,
          format: newType,
          append: append,
          prepend: prepend
        };
        break;
      }

    case 'data':
    case 'bibtex':
    case 'bibtxt':
    case 'ndjson':
    case 'ris':
      formatOptions = {
        type: newType
      };
      break;

    default:
      throw new Error("Invalid style \"".concat(newStyle, "\""));
  }

  var result = this.format(newStyle, Object.assign(formatOptions, options._newOptions));
  var format = parsedOptions.format;

  if (format === 'real' && newType === 'html' && typeof document !== 'undefined' && typeof document.createElement === 'function') {
    var tmp = document.createElement('div');
    tmp.innerHTML = result;
    return tmp.firstChild;
  } else if (format === 'string' && typeof result === 'object') {
    return JSON.stringify(result);
  } else {
    return result;
  }
}